import { render, staticRenderFns } from "./File.vue?vue&type=template&id=1adf9623&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=1adf9623&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf9623",
  null
  
)

export default component.exports